import React from 'react'
import clsx from 'clsx'
import { Icon } from '../Icon'
import style from './styles.module.scss'

export type ActivityLogButtonProps = {
  disabled?: boolean
  label?: string
  onClick?: () => void
} & React.StyledProps

export const ActivityLogButton: React.StyledFC<ActivityLogButtonProps> = ({
  className,
  disabled,
  label = '履歴',
  onClick,
}: ActivityLogButtonProps) => {
  return (
    <button
      type="button"
      className={clsx(style.root, className)}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon icon="history" className={style.icon} />
      <span className={style.label}>{label}</span>
    </button>
  )
}
